export default __webpack_public_path__ + "static/iphone-e086b78777f4aa1ce7ad78fa0b7f3706.mp4";